















import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "csvDropzoneComponent",
  components: {},
})
export default class csvDropzoneComponent extends Vue {
  public name: "csvDropzoneComponent";

  public onFilePicked(event) {
    const file = event.target.files[0];

    this.$emit("uploadCsv", file);

    const input = this.$refs.fileInput as HTMLInputElement;
    input.value = null;
  }
}
